/* Wohlform theme — cart drawer, ajax cart, reveals */
(function(){
  var money = function(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  };
  var drawer = document.getElementById('CartDrawer');

  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); document.body.style.overflow=''; } }

  function render(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      if(cart.item_count>0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
    });
    if(!drawer) return;
    var wrap = drawer.querySelector('[data-drawer-items]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    if(cart.item_count===0){
      wrap.innerHTML = '<div class="drawer__empty"><p style="font-family:Marcellus,serif;font-size:20px;color:#43352C">Dein Warenkorb ist leer</p><p style="margin-top:8px">Entdecke unsere Helfer für Nacken, Schlaf und Ruhe.</p></div>';
      if(foot) foot.style.display='none';
      return;
    }
    if(foot) foot.style.display='block';
    wrap.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2') : '';
      var opts = (it.options_with_values||[]).filter(function(o){return o.value!=='Default Title';}).map(function(o){return o.value;}).join(' · ');
      return '<div class="line-item" data-key="'+it.key+'">'+
        '<img class="line-item__img" src="'+img+'" alt="'+it.product_title+'" loading="lazy">'+
        '<div class="line-item__info">'+
          '<div class="line-item__title">'+it.product_title+'</div>'+
          (opts?'<div class="line-item__variant">'+opts+'</div>':'')+
          '<div class="line-item__row">'+
            '<div class="line-qty">'+
              '<button data-change="-1" aria-label="Weniger">−</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button data-change="1" aria-label="Mehr">+</button>'+
            '</div>'+
            '<div class="line-item__price">'+money(it.final_line_price)+'</div>'+
          '</div>'+
        '</div>'+
      '</div>';
    }).join('');
    var sub = drawer.querySelector('[data-drawer-subtotal]');
    if(sub) sub.textContent = money(cart.total_price);
    var bar = drawer.querySelector('[data-freeship]');
    if(bar){
      bar.textContent = 'Kostenloser Versand inklusive ✓';
    }
  }

  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  function addToCart(form){
    var btn = form.querySelector('[type=submit]');
    if(btn){ btn.dataset.label = btn.textContent; btn.textContent = 'Wird hinzugefügt …'; btn.disabled = true; }
    var data = new FormData(form);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:data})
      .then(function(r){return r.json();})
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(){ if(btn){ btn.textContent = btn.dataset.label; btn.disabled = false; } });
  }

  function changeQty(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(render);
  }

  document.addEventListener('click',function(e){
    var open = e.target.closest('[data-cart-toggle]');
    if(open){ e.preventDefault(); getCart().then(function(c){render(c);openDrawer();}); }
    if(e.target.closest('[data-drawer-close]')) closeDrawer();
    var chg = e.target.closest('[data-change]');
    if(chg){
      var li = chg.closest('.line-item'); if(!li) return;
      var cur = parseInt(li.querySelector('.line-qty span').textContent,10);
      changeQty(li.dataset.key, Math.max(0, cur + parseInt(chg.dataset.change,10)));
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });

  document.addEventListener('submit',function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if(form){ e.preventDefault(); addToCart(form); }
  });

  document.addEventListener('click',function(e){
    var s = e.target.closest('[data-qty-step]'); if(!s) return;
    var input = s.parentNode.querySelector('input'); if(!input) return;
    var v = Math.max(1,(parseInt(input.value,10)||1)+parseInt(s.dataset.qtyStep,10));
    input.value = v;
  });

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  getCart().then(render).catch(function(){});
})();
